import loading_report from "./loading_report.json";
import av from "./av.png";
import codec from "./codec.png";
import device from "./device.png";
import gateway from "./gateway.png";
import laptop from "./laptop.png";
import monitor from "./monitor.png";
import projector from "./projector.png";
import tablet from "./tablet.png";
import room from "./room.png";
import coloredlogo from "./oldlogo.png";
import account from "./account.png";
import location from "./location.png";
import user from "./user.png";

export const Loading_Report = loading_report;
export const av_logo = av;
export const codec_logo = codec;
export const device_logo = device;
export const gateway_logo = gateway;
export const laptop_logo = laptop;
export const monitor_logo = monitor;
export const projector_logo = projector;
export const tablet_logo = tablet;
export const room_logo = room;
export const colored_logo = coloredlogo;
export const account_logo = account;
export const location_logo = location;
export const user_logo = user;
